// extracted by mini-css-extract-plugin
module.exports = {"chip":"informations_chip__3gobj"};